import React     from 'react'
import PropTypes from 'prop-types'

import { AdminForm, AdminTable, AdminPage } from 'alto-react-components/lib/components'
import CanteenRepository, { CourseGroup }   from 'alto-react-canteen/lib/models'

class CourseGroupTable extends AdminTable
  model: CourseGroup
  idColumn: false
  @defaultOrdering: 'orderNumber'

  columns: ->
    [{
       property: 'orderNumber'
       header:
         label: 'Pořadové číslo'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'contains'
     }, {
       property: 'name'
       header:
         label: 'Identifikátor'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       property: 'displayName'
       header:
         label: 'Název'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       property: 'servedAt'
       header:
         label: 'Podávat v'
         formatters: [@orderable]
       cell:
         formatters: [(time) -> time?.format('H:mm')]
     }, {
       property: 'lockBefore'
       header:
         label: 'Uzamknout před'
         formatters: [@orderable]
       cell:
         formatters: [(duration) -> duration?.format('H:mm')]
     }]

class CourseGroupForm extends AdminForm
  model: CourseGroup

  inputs: ->
    nameInput = switch @props.action
      when 'create'
        label:     'Identifikátor'
        property:  'name'
        validator: ['notEmpty', /^[a-z0-9_]+$/]
        help:      'Databázový identifikátor, pouze malá písmena, čísla a _'
      when 'update'
        type:     'static'
        label:    'Identifikátor'
        property: 'name'

    [nameInput,
     {
       label:     'Název'
       property:  'displayName'
       validator: 'notEmpty'
     }, {
       label:     'Pořadové číslo'
       property:  'orderNumber'
       type:      'integer'
       validator: 'notEmpty'
     }, {
       type:      'time-as-duration'
       label:     'Podávat v'
       property:  'servedAt'
       help:      'Formát: HH:MM'
       validator: 'notEmpty'
     }, {
       type:      'duration'
       label:     'Uzamknout před'
       property:  'lockBefore'
       validator: 'notEmpty'
       help:      <span>Formát: H+:MM<br />Odečtením této doby od času podávání se vypočítá čas uzamčení</span>
     }]

export default class CourseGroupManagement extends AdminPage
  @contextTypes = { backend: PropTypes.object }

  tableComponent: CourseGroupTable
  formComponent:  CourseGroupForm

  relation: ->
    @__relation ?= CanteenRepository.forBackend(@context.backend).courseGroups
